import type { SummaryDetailLevel } from '@/client/types.gen'

/** Ascending detail level order for the analysis modal dropdown (Niveau 1 → 3). */
export const SUMMARY_DETAIL_LEVEL_SELECT_ORDER: readonly SummaryDetailLevel[] = [
	'overview',
	'standard',
	'detailed',
]
